import * as React from "react";
import { Rnd } from "react-rnd";
import styled from "styled-components";
import RndClose from "../RndClose/RndClose";
import { Input } from "@mui/joy";
import { ITodo } from "../../../../types/interface";
import TodoItem from "./TodoItem/TodoItem";
import { GiNotebook } from "react-icons/gi";
import { BiNotepad } from "react-icons/bi";
import { showPopupType } from "../../Sidebar";
export interface NoteProps {
  showNotePopup: boolean;
  onShow: React.Dispatch<React.SetStateAction<showPopupType>>;
}
interface HandleNewTodos {
  (todos: ITodo[]): ITodo[];
}
const syncReactToLocal = (handleNewTodos: HandleNewTodos) => {
  const todoString = localStorage.getItem("todos");
  const todoObj: ITodo[] = JSON.parse(todoString || "[]");
  const newTodosObj = handleNewTodos(todoObj);
  localStorage.setItem("todos", JSON.stringify(newTodosObj));
};
function Note({ showNotePopup, onShow }: NoteProps) {
  const [todos, setTodos] = React.useState<ITodo[]>([]);
  const [name, setName] = React.useState<string>("");
  const [currentTask, setCurrentTask] = React.useState<ITodo | null>(null);
  const doneTasks = todos.filter((task) => task.done);
  const notdoneTasks = todos.filter((task) => !task.done);
  React.useEffect(() => {
    const todoString = localStorage.getItem("todos");
    const todosObj: ITodo[] = JSON.parse(todoString || "[]");
    setTodos(todosObj);
  }, []);

  const handleSubmit = () => {
    if (currentTask) {
      finishEditTask();
      if (name) setName("");
    } else {
      addTodo(name);
      setName("");
    }
  };

  const onChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (currentTask) {
      editTask(value);
    } else {
      setName(value);
    }
  };
  const addTodo = (name: string) => {
    const newTask: ITodo = {
      id: new Date().toISOString(),
      name,
      done: false,
    };

    setTodos((prevTask) => [...prevTask, newTask]);
    syncReactToLocal((todoObj: ITodo[]) => [...todoObj, newTask]);
  };
  const handleDoneTask = (id: string, done: boolean) => {
    setTodos((prevTask) => {
      return prevTask.map((task) => {
        if (task.id === id) {
          return { ...task, done: done };
        }
        return task;
      });
    });
  };
  const startEditTodo = (id: string) => {
    const existTask = todos.find((task) => task.id === id);
    if (existTask) {
      setCurrentTask(existTask);
    }
  };
  const editTask = (name: string) => {
    setCurrentTask((prev) => {
      if (prev) {
        return { ...prev, name };
      }

      return null;
    });
  };
  const finishEditTask = () => {
    const handler = (todoObj: ITodo[]) => {
      return todoObj.map((task) => {
        if (task.id === (currentTask as ITodo).id) {
          return currentTask as ITodo;
        }
        return task;
      });
    };
    setTodos(handler);
    setCurrentTask(null);
    syncReactToLocal(handler);
  };
  const handleDeleteTask = (idTask: string) => {
    if (currentTask) {
      setCurrentTask(null);
    }
    const handler = (todoObj: ITodo[]) => {
      const findIndexTodo = todoObj.findIndex((todo) => todo.id === idTask);
      if (findIndexTodo > -1) {
        const result = [...todoObj];
        result.splice(findIndexTodo, 1);
        return result;
      }
      return todoObj;
    };
    setTodos(handler);
    syncReactToLocal(handler);
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };
  return (
    <Rnd
      style={{
        zIndex: 300,
      }}
      enableResizing={false}
      dragHandleClassName="dragHandlePdf"
    >
      <StyledNote
        style={{
          display: showNotePopup ? "" : "none",
        }}
        className="absolute flex flex-col  border-[hsla(0,0%,100%,.1)] popup-menu top-0 -left-[350px] bg-alphaBg px-3 rounded-lg"
      >
        <RndClose
          onClose={() =>
            onShow((prev) => {
              return {
                ...prev,
                showNotePopup: !prev.showNotePopup,
              };
            })
          }
        />
        <div className="w-80 pb-5 has-scrollbar h-96">
          <span className="text-white text-xl font-medium">Todos</span>
          <div className="todo-layout flex flex-col gap-y-3 mt-3 relative">
            <div className="add-todo h-9 flex items-center gap-x-2">
              <Input
                onChange={onChangeInput}
                value={currentTask ? currentTask.name : name}
                placeholder="Type in here…"
                className="flex-1  flex-shrink-0"
                color="warning"
                size="sm"
                variant="outlined"
                onKeyDown={handleKeyDown}
              />
              <button onClick={handleSubmit} className="shadow__btn">
                {currentTask ? "Edit" : "Add"}
              </button>
            </div>
            <div className="task-container flex flex-col gap-y-3">
              <div className="task-not-complete flex flex-col gap-y-1">
                <div className="text-primary flex items-center gap-x-2 text-base">
                  <BiNotepad className="text-xl" />
                  <span> Task to do</span>
                </div>
                {notdoneTasks.length > 0 &&
                  notdoneTasks.map((task) => {
                    return (
                      <TodoItem
                        task={task}
                        key={task.id}
                        handledoneTask={handleDoneTask}
                        startEditTask={startEditTodo}
                        handleDeleteTask={handleDeleteTask}
                      />
                    );
                  })}
              </div>
              <div className="task-complete flex flex-col gap-y-1">
                <div className="text-primary flex items-center gap-x-2 text-base">
                  <GiNotebook className="text-xl" />
                  <span>Task completed</span>
                </div>
                {doneTasks.length > 0 &&
                  doneTasks.map((task) => {
                    return (
                      <TodoItem
                        task={task}
                        key={task.id}
                        handledoneTask={handleDoneTask}
                        startEditTask={startEditTodo}
                        handleDeleteTask={handleDeleteTask}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </StyledNote>
    </Rnd>
  );
}
export default React.memo(Note);
const StyledNote = styled.div`
  .MuiInput-sizeSm {
    border-radius: 4px;
    background-color: hsla(0, 0%, 100%, 0.05);
    color: #fff;
    flex: 1;
    flex-shrink: 0;
    width: 238px;
  }
  .shadow__btn {
    margin-right: 4px;
    padding: 6px 12px;
    border: none;
    font-size: 14px;
    color: #fff;
    border-radius: 4px;
    letter-spacing: 4px;
    font-weight: 700;
    text-transform: uppercase;
    transition: 0.5s;
    transition-property: box-shadow;
  }

  .shadow__btn {
    background: #f3a952;
    box-shadow: 0 0 16px #f3a952;
  }

  .MuiCheckbox-root {
    color: #8ac926;
    /* color: #f9a825; */
    padding: 4px;
  }
  .css-zun73v.Mui-checked,
  .css-zun73v.MuiCheckbox-indeterminate,
  .MuiButtonBase-root,
  .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked,
  .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.MuiCheckbox-indeterminate {
    /* color: #f9a825; */
    color: #8ac926 !important;
  }
`;
